(function () {
  function init(section) {
    var buttons = section.querySelectorAll('[data-mode-target]');
    var slides = section.querySelectorAll('[data-mode-slide]');
    var productSlides = section.querySelectorAll('[data-mode-product-slide]');
    var videoSlides = section.querySelectorAll('[data-mode-video-slide]');
    var composite = section.querySelector('.plm__composite');
    if (!buttons.length || !slides.length) return;

    function activate(index) {
      var activeBtn = null;
      buttons.forEach(function (btn) {
        var isActive = btn.getAttribute('data-mode-target') === String(index);
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) activeBtn = btn;
      });
      slides.forEach(function (slide) {
        var isActive = slide.getAttribute('data-mode-slide') === String(index);
        slide.classList.toggle('is-active', isActive);
      });
      productSlides.forEach(function (slide) {
        var isActive = slide.getAttribute('data-mode-product-slide') === String(index);
        slide.classList.toggle('is-active', isActive);
      });
      videoSlides.forEach(function (slide) {
        var isActive = slide.getAttribute('data-mode-video-slide') === String(index);
        slide.classList.toggle('is-active', isActive);
      });
      if (composite && activeBtn) {
        var mediaType = activeBtn.getAttribute('data-media-type') || 'image';
        composite.setAttribute('data-active-media', mediaType);
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-mode-target'));
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var idx = Array.prototype.indexOf.call(buttons, btn);
        var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
        if (next < 0) next = buttons.length - 1;
        if (next >= buttons.length) next = 0;
        buttons[next].focus();
        activate(buttons[next].getAttribute('data-mode-target'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-product-lighting-modes]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-product-lighting-modes]');
    if (section) init(section);
  });
})();
